import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import Leistungen from '../pages/leistungen/page';
import UeberMich from '../pages/ueber-mich/page';
import Termin from '../pages/termin/page';
import Impressum from '../pages/impressum/page';
import Datenschutz from '../pages/datenschutz/page';
import FAQ from '../pages/faq/page';
import Standort from '../pages/standort/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/leistungen',
    element: <Leistungen />,
  },
  {
    path: '/ueber-mich',
    element: <UeberMich />,
  },
  {
    path: '/termin',
    element: <Termin />,
  },
  {
    path: '/faq',
    element: <FAQ />,
  },
  {
    path: '/standort',
    element: <Standort />,
  },
  {
    path: '/impressum',
    element: <Impressum />,
  },
  {
    path: '/datenschutz',
    element: <Datenschutz />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
